import { useRuntimeConfig } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { useCareLogger } from '../../../composables/logger/useCareLogger'

import { validateAllowedUsersByCountry } from './useAuthorizeIntercomUsers.utils'

export const useAuthorizeIntercomUsers = () => {
  const { logIntercomError } = useCareLogger()
  const { market } = useMarketplace()
  const { FF_INTERCOM_USER_ACCESS_BY_COUNTRY } = useRuntimeConfig().public

  const { user } = useUserStore()

  function checkAuthorizedIntercomUsers() {
    const { success } = validateAllowedUsersByCountry({
      allowedUsersByCountry: FF_INTERCOM_USER_ACCESS_BY_COUNTRY,
      countryCode: market.countryCode,
      userId: user.value?.clientId,
    })

    if (!success) {
      logIntercomError({
        errorTitle:
          '[INTERCOM] error with feature flag FF_INTERCOM_USER_ACCESS_BY_COUNTRY',
        errorDetail: {
          context:
            'The value of FF_INTERCOM_USER_ACCESS_BY_COUNTRY feature flag must be a list of client id(s) or set to all',
          feature_flag_value: FF_INTERCOM_USER_ACCESS_BY_COUNTRY,
        },
      })
    }

    return success
  }

  return { checkAuthorizedIntercomUsers }
}
